import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import SupportIcon from '@components/SupportSection/shared/SupportIcon';
import SupportContactUsStyles from '@/components/SupportSection/SupportContactUs/SupportContactUsStyles';
import useMediaQuery from '@/helpers/hooks/useMediaQuery';
import { isChatHours } from '@/services/isChatHours';

const SupportContactUs = ({ data, toggleScheduler }) => {
  const {
    hero_image,
    testimonial,
  } = data;
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 576px)');

  useEffect(() => {
    const getOpenHours = async () => {
      const isOpen = await isChatHours({

      });
      if (isOpen) {
        setIsOpen(true);
      }
      return;
    };

    getOpenHours();
  }, []);

  return (
    <SupportContactUsStyles>
      <div className="header-container">
        <div className="page-title">Contact Us</div>
        <div className="header-background">
          <div className="brown-background">
            <img className="header-image" src={isMobile ? testimonial.image : hero_image} />
          </div>
          <div className="header-details">
            <div className="header">
              Existing Customers
            </div>
            <div className="header-title">
              Talk directly to your accountant team
            </div>
            <Link href="/portal/#/message_center">
              <button className="message-btn btn btn-primary">Send a Message</button>
            </Link>
            <Link href="/portal/#/calendar">
              <button className="call-btn btn btn-primary">Schedule a Call</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="info-container">
        <div className="info-header">
          Other Options
        </div>
        <div className="icons-container">
          {isOpen ?
            <div className="chat-icon icon drift-open-chat">
              <div className="icon-image">
                <img src={"/icons/chat-open.svg"} alt="open chat image" />
              </div>
              <div className="icon-text-container">
                <div className="open icon-title">
                  Chat Right Now
                </div>
                <div className="open icon-description">Available</div>
              </div>
            </div>
            :
            <div className="icon">
              <div className="icon-image">
                <img src={"/icons/chat-closed.svg"} alt="closed chat image" />
              </div>
              <div className="icon-text-container">
                <div className="closed icon-title">
                  Chat is Unavailable
                </div>
                {/* Comment out in case we need to deploy w/o chat functionality */}
                <div className="closed icon-description">Open 9:30am-12:00pm and 2:00-6:30pm EST Monday-Friday</div>
              </div>
            </div>
          }
          <Link href="/support/billing">
            <div className="billing-icon icon">
              <div className="icon-image">
                <img src={"/icons/billing-support-icon.svg"} alt="billing image" />
              </div>
              <div className="icon-text-container">
                <div className="icon-title">
                  Contact Billing
                </div>
              </div>
            </div>
          </Link>
          <div className="schedule-icon icon" onClick={toggleScheduler}>
            <div className="icon-image">
              <img src={"/icons/support-scheduler-full.svg"} alt="scheduler image" />
            </div>
            <div className="icon-text-container">
              <div className="icon-title">
                Schedule a free call with our sales team
              </div>
            </div>
          </div>
          <div className="email-icon icon">
            <div className="icon-image">
              <img src={"/icons/support-email.svg"} alt="email image" />
            </div>
            <div className="email-text-container">
              <div className="icon-title">Email Us</div>
              <div className="icon-text-container">
                <div>
                  <div className="icon-description">Media Relations</div>
                  <div className="icon-link">
                    <a href="mailto:media@1800accountant.com">media@1800accountant.com</a>
                  </div>
                </div>
                <div>
                  <div className="icon-description partnerships">Partnerships</div>
                  <div className="icon-link">
                    <a href="mailto:partners@1800accountant.com">partners@1800accountant.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SupportContactUsStyles>
  );
};

export default SupportContactUs;